<template>
  <div class="file-modal-border">
    <app-modal
      :modal-id="modalId"
      modal-alignment="center"
      modal-size="medium"
      data-backdrop="static"
      data-keyboard="false"
      style="background:rgba(0, 0, 0, .5)"
      >
      <template slot="header">

        <button
        type="button"
        class="close outline-none"
        data-dismiss="modal"
        @click="closeModal"
      >
        <span>
          <app-icon :name="'x'"></app-icon>
        </span>
      </button>
      </template>
      <template slot="body">
        <div class="row">
          <div class="col-md-12">
            <img id="myImg" :src="imagePath" alt="Image Not Found" width="" height="">
          </div>
        </div>
      </template>

      <template slot="footer">
        <button
          type="button"
          class="btn btn-primary mr-2"
          data-dismiss="modal"
          @click="closeModal"
        >
          {{ $t("close") }}
        </button>
      </template>
    </app-modal>
  </div>
</template>

<script>
import { ModalMixin } from "../../../../../app/Mixins/ModalMixin";
import CoreLibrary from "../../../../../core/helpers/CoreLibrary.js";

export default {
  name: "File",
  extends: CoreLibrary,
  mixins: [ModalMixin],
  props: {
    imagePath: String,
    componentId: String,
  },
  data() {
    return {
      modalId: "preview_image_modal",
    };
  },
  methods: {
   
  },
};
</script>

<style>
#myImg {
    border-radius: 5px;
    cursor: pointer;
    transition: 0.3s;
    max-width: 100%;
    max-height: 100%;
}
</style>